<app-elevation-section [title]="languageService.LNG('Label.Equipment')">
  <div class="grid-totals-wrapper">
    <dx-select-box
      [dataSource]="{store: equipmentDataSource, paginate: true, pageSize: 10}"
      displayExpr="DisplayName"
      searchExpr="DisplayName"
      valueExpr="EquipmentId"
      [searchEnabled]="true"
      [showClearButton]="true"
      [(value)]="newEquipment.EquipmentId"
      [readOnly]="isEditingDisabled"
      placeholder="{{languageService.LNG('Label.Equipment')}}"
      (onEnterKey)="createNewEquipment()">
    </dx-select-box>
    <dx-select-box
      [dataSource]="equipmentTypes"
      displayExpr="Name"
      searchExpr="Name"
      valueExpr="Id"
      [searchEnabled]="true"
      [showClearButton]="true"
      [(value)]="newEquipment.EquipmentTypeId"
      [readOnly]="isEditingDisabled"
      placeholder="{{equipmentTypeLabel}}"
      (onEnterKey)="createNewEquipment()">
    </dx-select-box>
    <dx-text-box placeholder="{{languageService.LNG('Label.Hours')}}" 
      [(value)]="newEquipment.Hours" 
      [readOnly]="isEditingDisabled"
      (onEnterKey)="createNewEquipment()">
      <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
    </dx-text-box>
    <dx-text-box placeholder="{{languageService.LNG('Label.Minutes')}}" 
      [(value)]="newEquipment.Minutes" 
      [readOnly]="isEditingDisabled"
      (onEnterKey)="createNewEquipment()">
      <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
    </dx-text-box>
</div>
  <dx-data-grid #datagriddx [dataSource]="gridDataSource"
              [rowAlternationEnabled]="true"
              [columnAutoWidth]="true"
              [height]="225"
              style="padding-bottom: 10px;"
              (onRowRemoving)="onRowRemoving($event)"
              (onRowUpdating)="onRowUpdating($event)"
              (onInitNewRow)="onInitNewRow($event)">
      <dxo-paging [pageSize]="15"></dxo-paging>
      <dxo-editing mode="cell"
                  [allowUpdating]="!isEditingDisabled"
                  [allowAdding]="false"
                  [allowDeleting]="!isEditingDisabled"
                  [useIcons]="true">
      </dxo-editing>
      <!-- <dxo-selection
          mode="multiple"
          showCheckBoxesMode="always">
      </dxo-selection> -->
      <dxo-load-panel [enabled]="true"></dxo-load-panel>
      <dxo-scrolling mode="virtual"></dxo-scrolling>

      <dxi-column dataField="EquipmentId" caption="{{languageService.LNG('Label.Equipment')}}"  >
          <dxo-lookup [dataSource]="{store: equipmentDataSource, paginate: true, pageSize: 10}"
            displayExpr="DisplayName"
            valueExpr="EquipmentId">
          </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="TotSecondsToHH" caption="{{languageService.LNG('Label.Hours')}}" [width]="65" alignment="right" [visible]="showEquipmentTime">
        <dxi-validation-rule type="range" min="0" [message]="validateHoursMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="TotSecondsTomm" caption="{{languageService.LNG('Label.Minutes')}}" [width]="80" alignment="left" [visible]="showEquipmentTime">
        <dxi-validation-rule type="range" min="0" max="59" [message]="validateMinutesMessage"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="IsMainEquipment" caption="{{languageService.LNG('Label.Main.Equipment')}}" [width]="100" dataType="boolean" ></dxi-column>
      <dxi-column dataField="LoadedEquipment" caption="{{languageService.LNG('Label.Loaded.Equipment')}}" [width]="100" dataType="boolean"></dxi-column>
      <div *dxTemplate="let data of 'headerTitle'">
        <span style="font-size: 20px;" >{{this.languageService.LNG("Label.Equipment")}}</span>
      </div>
  </dx-data-grid>
</app-elevation-section>
